var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDSignalCoolingPumpVariableOpt2 = function SvgDSignalCoolingPumpVariableOpt2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 448,
    width: 20,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,449v26H9v-26h18M28,448H8v28h20v-28h0Z",
    fill: "#1c9d5b"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "13.71 461.61 23.48 451.84 22.77 451.13 13 460.91 13 450.11 12 450.11 12 462.61 24.5 462.61 24.5 461.61 13.71 461.61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "23.47 463.49 21.26 464.08 21.84 464.66 13.4 473.1 13.86 473.56 22.3 465.12 22.88 465.7 23.47 463.49",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17.88,
    cy: 469.02,
    r: 5.25,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.88,464.1c2.71,0,4.92,2.21,4.92,4.92s-2.21,4.92-4.92,4.92-4.92-2.21-4.92-4.92,2.21-4.92,4.92-4.92M17.88,463.77c-2.9,0-5.25,2.35-5.25,5.25s2.35,5.25,5.25,5.25,5.25-2.35,5.25-5.25-2.35-5.25-5.25-5.25h0Z",
    fill: "#f60"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "20.83 469.02 14.93 472.71 14.93 465.33 20.83 469.02",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.42 468.03 20.97 468.93 20.97 467.13 22.42 468.03",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1,468.29v.64h-.39v-1.81h.74c.14,0,.27.02.38.07.11.05.19.12.25.21.06.09.09.2.09.31,0,.18-.06.32-.19.42s-.3.15-.53.15h-.34ZM14.1,467.99h.35c.1,0,.18-.02.24-.07s.08-.11.08-.2-.03-.16-.08-.21-.13-.08-.23-.08h-.36v.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.87,467.12v1.19c0,.2-.06.35-.19.47s-.31.17-.53.17-.4-.06-.53-.17c-.13-.11-.2-.27-.2-.46v-1.2h.39v1.19c0,.12.03.2.09.26.06.05.14.08.25.08.22,0,.33-.11.33-.33v-1.2h.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7,467.12l.49,1.31.48-1.31h.51v1.81h-.39v-.49l.04-.85-.51,1.35h-.27l-.51-1.35.04.85v.49h-.39v-1.81h.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.81,468.29v.64h-.39v-1.81h.74c.14,0,.27.02.38.07.11.05.19.12.25.21.06.09.09.2.09.31,0,.18-.06.32-.19.42s-.3.15-.53.15h-.34ZM19.81,467.99h.35c.1,0,.18-.02.24-.07s.08-.11.08-.2-.03-.16-.08-.21-.13-.08-.23-.08h-.36v.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.59,470.11c0,.15-.02.28-.06.39-.04.11-.1.2-.17.25-.07.06-.16.09-.26.09s-.18-.03-.25-.09-.13-.14-.17-.25-.06-.23-.06-.38v-.11c0-.15.02-.27.06-.39s.1-.2.17-.26c.07-.06.16-.09.25-.09s.18.03.26.09.13.14.17.26c.04.11.06.24.06.39v.1ZM14.43,470.01c0-.18-.03-.32-.09-.41-.06-.1-.14-.14-.24-.14s-.18.05-.24.14-.09.23-.09.4v.11c0,.17.03.31.09.41.06.1.14.15.24.15s.18-.05.24-.14c.06-.09.09-.23.09-.4v-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99,470.22v.59h-.16v-1.52h.45c.13,0,.24.04.31.13.08.08.11.2.11.34,0,.15-.04.26-.11.34-.07.08-.18.12-.32.12h-.29ZM14.99,470.06h.29c.09,0,.15-.03.2-.08.05-.05.07-.12.07-.22,0-.09-.02-.16-.07-.22-.05-.05-.11-.08-.19-.08h-.3v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.74,469.46h-.39v1.35h-.16v-1.35h-.39v-.16h.94v.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,470.81h-.16v-1.52h.16v1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.59,469.3l.4,1.24.4-1.24h.21v1.52h-.16v-.59l.02-.64-.4,1.23h-.12l-.4-1.22.02.63v.59h-.16v-1.52h.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05,470.81h-.16v-1.52h.16v1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.46,470.65h.69v.16h-.88v-.15l.66-1.2h-.65v-.16h.85v.15l-.67,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.05,470.11h-.53v.54h.61v.16h-.77v-1.52h.76v.16h-.6v.49h.53v.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.78,470.2h-.28v.61h-.16v-1.52h.4c.14,0,.24.04.32.12.07.08.11.19.11.34,0,.09-.02.18-.06.25-.04.07-.1.12-.17.16l.28.64h0s-.17.01-.17.01l-.26-.61ZM21.49,470.04h.25c.08,0,.14-.03.19-.08s.07-.12.07-.21c0-.09-.02-.17-.07-.22s-.11-.08-.19-.08h-.24v.58Z"
  })))))));
};
export default SvgDSignalCoolingPumpVariableOpt2;